module.exports = __webpack_public_path__ + "img/sport_basketball.82618cd5.png";